module.exports = __webpack_public_path__ + "static/img/style2.2dcb119.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/title/style2.png
// module id = mV+s
// module chunks = 0